import { render, staticRenderFns } from "./EditApFormPopup.vue?vue&type=template&id=61764ae4&"
import script from "./EditApFormPopup.vue?vue&type=script&lang=js&"
export * from "./EditApFormPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports